export * from './merkmal.actions';
export * from './merkmal.reducer';
export * from './merkmal.selectors';
export * from './merkmal.state';
export * from './merkmal.effects';
